import { render, staticRenderFns } from "./ChickList.vue?vue&type=template&id=8ed78ecc&scoped=true&"
import script from "./ChickList.vue?vue&type=script&lang=js&"
export * from "./ChickList.vue?vue&type=script&lang=js&"
import style0 from "./ChickList.vue?vue&type=style&index=0&id=8ed78ecc&lang=scss&scoped=true&"
import style1 from "./ChickList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed78ecc",
  null
  
)

export default component.exports